var mask2v2 = "/static/b5f2ce39d09970c9.png";

export { mask2v2 as default };
//# sourceMappingURL=mask-2-v2.png.js.map
